import { createContext, useContext, useReducer, useEffect } from "react";
import { storage } from "../utils/storage";

const CartContext = createContext();
const CART_STORAGE_KEY = 'cart_data';

export const useCart = () => useContext(CartContext);

const initialState = {
  items: [],
};

function cartReducer(state, action) {
  let newState;
  switch (action.type) {
    case "ADD_TO_CART":
      const existingItem = state.items.find(i => i.id === action.payload.id);
      if (existingItem) {
        newState = {
          ...state,
          items: state.items.map(item =>
            item.id === action.payload.id
              ? { ...item, qty: item.qty + 1 }
              : item
          ),
        };
      } else {
        newState = {
          ...state,
          items: [...state.items, { ...action.payload, qty: 1 }],
        };
      }
      break;

    case "REMOVE_FROM_CART":
      newState = {
        ...state,
        items: state.items.filter(i => i.id !== action.payload.id),
      };
      break;

    case "UPDATE_QUANTITY":
      newState = {
        ...state,
        items: state.items.map(item =>
          item.id === action.payload.id
            ? { ...item, qty: action.payload.qty }
            : item
        ),
      };
      break;

    case "CLEAR_CART":
      newState = { items: [] };
      break;

    case "INIT_CART":
      newState = action.payload;
      break;

    default:
      newState = state;
  }

  // Save to storage after each state change
  storage.set(CART_STORAGE_KEY, newState);
  return newState;
}

export function CartProvider({ children }) {
  const [cart, dispatch] = useReducer(cartReducer, storage.get(CART_STORAGE_KEY) || initialState);

  // Initialize cart from storage
  useEffect(() => {
    const savedCart = storage.get(CART_STORAGE_KEY);
    if (savedCart) {
      dispatch({ type: "INIT_CART", payload: savedCart });
    }
  }, []);

  return (
    <CartContext.Provider value={{ cart, dispatch }}>
      {children}
    </CartContext.Provider>
  );
}
